import { IExportPlugin, PluginType } from '@/version-types';
import cursorPlugin from './cursor-plugin';
import editPlugin from './edit-plugin';
import { RealEdit } from './index';
import { RoomOperate } from './view/room-operate';

const exportPlugin: IExportPlugin = {
    type: PluginType.SYSTEM,
    sort: 3,
    name: 'real-edit-system',
    dependencies() {
        return [{ plugin: cursorPlugin }, { plugin: editPlugin }];
    },
    createInstance({ identity }) {
        return [{ key: 'RealEdit', value: new RealEdit(identity) }];
    },
    destroy({ getInstance }) {
        getInstance(RealEdit).room.destroy();
    },
    render() {
        return <RoomOperate />;
    },
};

export default exportPlugin;
